import { Component } from '@angular/core';
import { FpContactComponent } from '../common/fp-contact/fp-contact.component';
import { FpCtaComponent } from '../common/fp-cta/fp-cta.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-contact',
    imports: [FpContactComponent, FpCtaComponent, TranslateModule],
    templateUrl: './contact.component.html',
    styleUrl: './contact.component.scss'
})
export class ContactComponent {
    
    
    
}